import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as CategoriesActions from './../actions/categories.actions';
import { catchError, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { selectCategories } from '../selectors/categories.selectors';

@Injectable()
export class CategoriesEffects {
  loadCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoriesActions.loadCategories),
      withLatestFrom(this.store.select(selectCategories)),
      mergeMap(([_, categories]) => {
        if (categories) {
          return of(CategoriesActions.alreadyLoaded());
        }
        return this.apiService.getCategories().pipe(
          map((categories) => CategoriesActions.loadCategoriesSuccess({ categories })),
          catchError((error) => of(CategoriesActions.loadCategoriesFailure({ error })))
        );
      })
    )
  );

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private store: Store
  ) {}
}
